import apiClient from "./http/apiClient";
import { RBAC } from "./modules/rbac.service";

const Accounts = {
  users: async (params = {}) => {
    const response = await apiClient.get("accounts/users/", { params });
    return response.data;
  },
  deleteUser: async (userId) => {
    const response = await apiClient.delete(`accounts/users/${userId}/`);
    return response.data;
  },
  setUserActive: async (userId, is_active) => {
    const response = await apiClient.patch(`accounts/users/${userId}/active/`, { is_active });
    return response.data;
  },
  getUserAccessSchedule: async (userId) => {
    const response = await apiClient.get(`accounts/users/${userId}/access-schedule/`);
    return response.data;
  },
  updateUserAccessSchedule: async (userId, payload) => {
    const response = await apiClient.patch(`accounts/users/${userId}/access-schedule/`, payload);
    return response.data;
  },
};

const API = apiClient;

export { RBAC, Accounts };
export default API;
